module.exports = __webpack_public_path__ + "img/icon-history.03918cec.svg";